import React, {useState} from 'react';
import {BreadCrumbsCourse} from "../../components/navigation/BreadCrumbsCourse";
import ComplexParser from "./ComplexParser";
import {Link, useOutletContext} from "react-router-dom";
import {CourseContextMenu} from "../../components/CourseContextMenu";
import {routes} from "../../utils/Routes";

export function CoursePage({chapter, togglePanelCallback, integratedAi = false}) {
    const [menuVisible, setMenuVisible] = useState(false);
    const [position, setPosition] = useState({x: 0, y: 0});

    const handleContextMenu = (event) => {
        event.preventDefault();
        setPosition({x: event.pageX, y: event.pageY});
        setMenuVisible(true);
    };

    const handleClick = () => {
        setMenuVisible(false);
    };


    const parser = new ComplexParser(false, chapter.chapterContent, null, [], null, null, chapter.sortOrder);

    const parsedContent = parser.parse();

    return (

        <div onClick={() => handleClick()}
             onContextMenu={(e) => handleContextMenu(e)}
             className={"container"}
             style={{fontFamily: "Poppins", maxWidth:"920px"}}>


            <h1 className={"m-0 p-0 py-5"}>{chapter.title}</h1>

            {
                parsedContent.map((item, idx) => (
                    <>
                        {item}
                    </>

                ))
            }

            {
                integratedAi ?
                    <CourseContextMenu show={menuVisible} x={position.x} y={position.y}
                                       explanationCallback={togglePanelCallback}/>
                    : null
            }

            <div className={"my-5"}></div>

        </div>


    );

}